import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { routing } from "./main.routing";
import { RouterTestingModule } from "@angular/router/testing";
import { MainComponent } from "./main.component";
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { SessionStorageService, LocalStorageService } from "ngx-webstorage";
import { SidebarService } from "./sidebar/sidebar.service";
import { UserGroupManagementService } from "./user-group-management/user-group-management.service";
import { LimitsService } from "./limits-capping/limits-wallet/limits.service";
import { LogoutService } from "./header/logout.service";
import { FinancialService } from "./reports/financial-reports/financial-reports.service";
import { TimeAgoPipe } from "time-ago-pipe";
import { ReferralComponent } from "./referral/referral.component";
import { CreateReferralComponent } from "./referral/create-referral/create-referral.component";
import { NoPermissionComponent } from "./no-permission/no-permission.component";
import { AgentRequestsService } from "./agent-requests/agent-requests.service";
import { BankRequestsService } from "./bank-requests/bank-requests.service";
import { KycService } from "./kyc/kyc.service";
// import { BenifitManagementComponent } from './benifit-management/benifit-management.component';
// import { GroupLimitManagementComponent } from './group-limit-management/group-limit-management.component';

import { SharedModule } from '../common/shared.module';

@NgModule({
  imports: [CommonModule, routing, RouterTestingModule, SharedModule],
  declarations: [
    MainComponent,
    HeaderComponent,
    SidebarComponent,
    TimeAgoPipe,
    ReferralComponent,
    CreateReferralComponent,
    NoPermissionComponent,
  ],
  providers: [
    SessionStorageService,
    LocalStorageService,
    UserGroupManagementService,
    SidebarService,
    LimitsService,
    FinancialService,
    LogoutService,
    AgentRequestsService,
    BankRequestsService,
    KycService,
  ],
})
export class MainModule { }




// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/main/main.module.ts